<template>
  <header :class="['dd-header', {'is-positioned': outOfFlow, 'is-transparent': transparent}]"
  @touchmove="handleTouchMove">
    <div class="dd-header__inner">
      <router-link to="/" class="dd-header__logo">
        <span>数鸽</span>
      </router-link>
      <div class="dd-header__trigger" @click="toggleNav">
        <span :class="['dd-header__trigger-icon', {'is-active': isOpenNav}]"></span>
      </div>    
      <div 
        :class="['dd-header__mask', {'is-show': isOpenNav}]" 
        @click="toggleNav">
      </div>         
      <nav :class="['dd-header__nav', {'is-active': isOpenNav}]">
        <router-link v-for="item in menus" :key="item.text" :to="item.to">
          {{item.text}}
        </router-link>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    outOfFlow: {
      type: Boolean,
      default: false
    },
    transparent: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpenNav: false,
      menus: [
        {
          to: '/',
          text: '首页'
        },
        {
          to: '/about',
          text: '关于数鸽'
        },
        {
          to: '/customer',
          text: '我们的客户'
        },
        {
          to: '/business',
          text: '商务合作'
        }
      ]
    }
  },
  methods: {
    toggleNav () {
      this.isOpenNav = !this.isOpenNav
    },
    handleTouchMove (evt) {
      if (this.isOpenNav) {
        evt.preventDefault()
      }
    }
  }
}
</script>

<style lang="scss">
.dd-header {
  position: relative;
  z-index: 9;
  background-color: #191919;

  &.is-positioned {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
  &.is-transparent {
    background-color: transparent;
  }
  &__inner {
    @extend %wrap;
    box-sizing: border-box;
    height: 100px;
    line-height: 100px;
    padding: 0 20px;
  }
  &__logo {
    float: left;
    
    span {
      display: inline-block;
      width: 160px;
      height: 50px;
      line-height: 50px;
      background: url("../assets/logo.png") center no-repeat;
      background-size: 100%;
      text-indent: -99em;
      overflow: hidden;
      vertical-align: middle;
    }
  }
  &__trigger {
    position: relative;
    z-index: 1;
    display: none;
    float: right;
    padding: 0 20px;
    margin: 0 -20px;
    cursor: pointer;

    @mixin bar {
      width: 25px;
      height: 2px;
      background: #fff;
      border-radius: 2px;
      transition: all .3s;
    }
    &-icon {
      position: relative;
      display: inline-block;
      vertical-align: middle;
      @include bar;

      &:before,
      &:after {
        content: "";
        position: absolute;
        @include bar;
      }
      &:before {
        bottom: 9px;
      }
      &:after {
        top: 9px
      }
      &.is-active {
        background: transparent;

        &:before {
          transform: rotate(45deg);
          transform-origin: left;
        }
        &:after {
          transform: rotate(-45deg);
          transform-origin: left;
        }
      }
    }
  }
  &__mask {
    display: none;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0,0,0, .5);
    transition: all .3s;
  }
  &__nav {
    text-align: right;
    user-select: none;
    
    a {
      color: #fff;
      margin-left: 9%;

      &:first-child {
        margin-left: 0;
      }
    }
  }

  @include media-tablet {
    &__logo {
      width: 125px;
      height: 38px;
    }
    &__trigger {
      display: block;
    }
    &__mask {
      display: block;
      visibility: hidden;
      opacity: 0;

      &.is-show {
        visibility: visible;
        opacity: 1;
      }
    }
    &__nav {
      position: fixed;
      top: 0;
      bottom: 0;
      right: 0;
      width: 250px;
      padding: 100px 25px;
      background: #191919;
      line-height: 1;
      text-align: left;
      visibility: hidden;
      transform: translate(100%, 0);
      transition: transform .3s;

      &.is-active {
        visibility: visible;
        transform: translate(0, 0);
      }
      a {
        display: block;
        padding: 22px 0;
        margin-left: 0;
      }
    }
  }
}
</style>
